import type {AppConfig} from './appConfig.types';
import {getConfig} from './config';

const getExternalLinksConfig = () => (getConfig() as AppConfig).externalLinks || {};

const getAutoDeliveryAsapRescheduleExternalLink = () => getExternalLinksConfig().autoDeliveryAsapRescheduleExternalLink;
const getAutoDeliveryEditAddressExternalLink = () => getExternalLinksConfig().autoDeliveryEditAddressExternalLink;
const getAutoDeliveryEditOrderExternalLink = () => getExternalLinksConfig().autoDeliveryEditOrderExternalLink;
const getAutoDeliveryInactiveExternalLink = () => getExternalLinksConfig().autoDeliveryInactiveExternalLink;
const getAutoDeliveryOnHoldDeliveryFailExternalLink = () =>
    getExternalLinksConfig().autoDeliveryOnHoldDeliveryFailExternalLink;
const getAutoDeliveryOnHoldNoneExternalLink = () => getExternalLinksConfig().autoDeliveryOnHoldNoneExternalLink;
const getAutoDeliveryOnHoldOutOfStockExternalLink = () =>
    getExternalLinksConfig().autoDeliveryOnHoldOutOfStockExternalLink;
const getAutoDeliveryOnHoldPayFailedExternalLink = () =>
    getExternalLinksConfig().autoDeliveryOnHoldPayFailedExternalLink;
const getAutoDeliveryOrderSummaryExternalLink = () => getExternalLinksConfig().autoDeliveryOrderSummaryExternalLink;
const getAutoDeliveryPaymentPendingExternalLink = () => getExternalLinksConfig().autoDeliveryPaymentPendingExternalLink;
const getAutoDeliverySkipGoToWebsiteExternalLink = () =>
    getExternalLinksConfig().autoDeliverySkipGoToWebsiteExternalLink;
const getAutoDeliveryTncExternalLink = () => getExternalLinksConfig().autoDeliveryTncExternalLink;
const getConsumerProfileExternalLink = () => getExternalLinksConfig().consumerProfileExternalLink;
const getDownloadChromeUrl = () => getExternalLinksConfig().downloadChromeUrl;
const getFirmwareAvailableCheckCompatibilityExternalLink = () =>
    getExternalLinksConfig().firmwareAvailableCheckCompatibilityExternalLink;
const getFirmwareAvailableLearnMoreExternalLink = () => getExternalLinksConfig().firmwareAvailableLearnMoreExternalLink;
const getIqosAppsLandingPageLink = () => getExternalLinksConfig().iqosAppsLandingPageLink;
const getIqosStoreExternalLink = () => getExternalLinksConfig().iqosStoreExternalLink;
const getLeviaCheckCompatibilityExternalLink = () => getExternalLinksConfig().leviaCheckCompatibilityExternalLink;
const getLeviaLearnMoreExternalLink = () => getExternalLinksConfig().leviaLearnMoreExternalLink;
const getMarketWebSiteExternalLink = () => getExternalLinksConfig().marketWebSiteExternalLink;
const getShopAccessoriesExternalLink = () => getExternalLinksConfig().shopAccessoriesExternalLink;
const getShopDevicesExternalLink = () => getExternalLinksConfig().shopDevicesExternalLink;
const getSupportExternalLink = () => getExternalLinksConfig().supportExternalLink;
const getTradeInExternalLink = () => getExternalLinksConfig().tradeInExternalLink;

export default {
    getAutoDeliveryAsapRescheduleExternalLink,
    getAutoDeliveryEditAddressExternalLink,
    getAutoDeliveryEditOrderExternalLink,
    getAutoDeliveryInactiveExternalLink,
    getAutoDeliveryOnHoldDeliveryFailExternalLink,
    getAutoDeliveryOnHoldNoneExternalLink,
    getAutoDeliveryOnHoldOutOfStockExternalLink,
    getAutoDeliveryOnHoldPayFailedExternalLink,
    getAutoDeliveryOrderSummaryExternalLink,
    getAutoDeliveryPaymentPendingExternalLink,
    getAutoDeliverySkipGoToWebsiteExternalLink,
    getAutoDeliveryTncExternalLink,
    getConsumerProfileExternalLink,
    getDownloadChromeUrl,
    getFirmwareAvailableCheckCompatibilityExternalLink,
    getFirmwareAvailableLearnMoreExternalLink,
    getIqosAppsLandingPageLink,
    getIqosStoreExternalLink,
    getLeviaCheckCompatibilityExternalLink,
    getLeviaLearnMoreExternalLink,
    getMarketWebSiteExternalLink,
    getShopAccessoriesExternalLink,
    getShopDevicesExternalLink,
    getSupportExternalLink,
    getTradeInExternalLink,
};
